import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select"]

  onChange(e) {
    window.location.href = e.currentTarget.value
  }
}
